export const worksData = [
    {
        name: "WPG New Life",
        description: "A mobile web app that works as a social networking platform that provides a place allowing new immigrants in Winnipeg to share daily news, trade stuffs, and post jobs. There are also other useful tools comes with it, such as a currency converter and a mortgage calculator.",
        type: "Industrial Project",
        url: "http://www.wpgnewlife.com",
        github: "https://github.com/ruitang2create/canadaasians-en-mobile",
        techs: ["React", "Node.js", "Express", "MySQL", "RESTful API"],
        mobile: true,
        desktop: false,
        public: false,
    },
    {
        name: "Summoner X",
        description: "A statistics website that portrays League of Legends players’ in-game performance by tracking and analyzing their gaming stats. Users can check any player's match history, rank information by searching a valid summoner id. Player's stats are presented with animated charts.",
        type: "Personal Side Project",
        url: "https://summonerx.com/",
        github: "https://github.com/ruitang2create/lol-profile",
        techs: ["Next.js", "React", "Chart.js"],
        mobile: true,
        desktop: true,
        publicRepo: true,
    },
    {
        name: "Agile Planner",
        description: "A simple project management tool that applies agile methodologies. You can create a vision statement and unlimited user stories for a project. You can later track and edit them easily. For each user story, besides its basic info, you can also record its priority level, estimated time cost and whether it's finished.",
        type: "Personal Side Project",
        url: "http://projectplanner.ruitangcs.com",
        github: "https://github.com/ruitang2create/project_planner",
        techs: ["React", "Node.js", "Express", "MySQL"],
        mobile: true,
        desktop: true,
        publicRepo: true,
    },
    {
        name: "Auto Scout",
        description: "An easy-to-use web app that allows user to search for auto models by vehicle make, type, and year.",
        type: "Personal Side Project",
        url: "https://auto-scout.vercel.app/",
        github: "https://github.com/ruitang2create/auto_scout",
        techs: ["React", "Bootstrap"],
        mobile: true,
        desktop: true,
        publicRepo: true,
    }
];